// This can just be used to force QuotePAgeApp to save to MongoDB

const save_redux_reducer = (state = false, action) => {
	switch(action.type) {
		case 'SAVEREDUX':
			return !state;

		default:
			return state;
	}
}

export default save_redux_reducer;